import { render, staticRenderFns } from "./SendToCard.vue?vue&type=template&id=0e796750&"
import script from "./SendToCard.vue?vue&type=script&lang=js&"
export * from "./SendToCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports